import { Divider, VStack, DataList, DataItem } from '@cad-arc';
import { EntityLocation } from './entity-location';
import { EntityTypes, MergedEntityTypes, Vehicle } from '../../../../../fr-entity-panels/types';
import { TOW_VEHICLES_ENTITY_TYPES } from '../../../constants';
import { CARD_CONTAINERS_PADDING } from '../constants';
import { CommonSize } from '../../../../../common/helpers/utils';
import { getDataItemText } from '../../../../../common/helpers/component-utils';

export function VehicleCardExpandableContent({
    vehicle,
    entityType,
    size,
}: {
    vehicle: Vehicle;
    entityType: EntityTypes | MergedEntityTypes;
    size?: CommonSize;
}) {
    const {
        vinNumber,
        year,
        notes,
        towCompanyOption,
        towTypeOption,
        towedFromLocation,
        towedToLocation,
    } = vehicle;

    return (
        <>
            <Divider />
            <VStack alignItems="flex-start" padding={CARD_CONTAINERS_PADDING} width="100%">
                <DataList direction="row">
                    <DataItem dataKey="VIN #">{getDataItemText(size, vinNumber)}</DataItem>
                    <DataItem dataKey="Year">
                        {getDataItemText(size, year ? String(year) : '')}
                    </DataItem>
                </DataList>
                {TOW_VEHICLES_ENTITY_TYPES.includes(entityType) && (
                    <DataList>
                        <DataItem dataKey="Tow Type">
                            {getDataItemText(size, towTypeOption?.label)}
                        </DataItem>
                        <DataItem dataKey="Tow Company">
                            {getDataItemText(size, towCompanyOption?.label)}
                        </DataItem>
                        <EntityLocation dataKey="Towed From" location={towedFromLocation} />
                        <EntityLocation dataKey="Towed To" location={towedToLocation} />
                    </DataList>
                )}
            </VStack>
            <Divider />
            <DataList style={{ width: '100%', padding: CARD_CONTAINERS_PADDING }}>
                <DataItem dataKey="Notes">{getDataItemText(size, notes)}</DataItem>
            </DataList>
        </>
    );
}
